import type { BoundElementDefinition } from '../types';
import type { BindingId } from '../../runtime/dataServices/types';
import { createDefaultImageGallerySettings, type ImageGallerySettings } from './contracts';
import { createRuntimeBindingInsertionPresetsForKind } from '../runtimeBindingPresetUtils';
import { createBoundElementDefinition } from '../types';

export type ImageGalleryDefinition = BoundElementDefinition<'image_gallery', ImageGallerySettings>;

export function createBlankImageGalleryDefinition(): ImageGalleryDefinition {
    return createBoundElementDefinition('image_gallery', {
        ...createDefaultImageGallerySettings(),
        binding: null,
    });
}

function createImageGalleryDefinitionForBindingId(bindingId: BindingId): ImageGalleryDefinition {
    return createBoundElementDefinition('image_gallery', {
        ...createDefaultImageGallerySettings(),
        binding: { bindingId },
    });
}

export function createRuntimeImageGalleryInsertionPresets() {
    return createRuntimeBindingInsertionPresetsForKind({
        valueKind: 'image-list',
        keyPrefix: 'image_gallery_binding',
        createDefinitionForBindingId: (bindingId) =>
            createImageGalleryDefinitionForBindingId(bindingId),
    });
}
